<div class="error-retry">
  <div>{{ text }}</div>
  <div *ngIf="icon">
    <ftr-icon icon="Error" size="Max" color="GreyLighter"></ftr-icon>
  </div>
  <div><button ftrButton [displayType]="buttonDisplayType.Text" (click)="onRetry()">Try again</button></div>
</div>
